import TEBasketAction from './te.class.basket-action.js';
import { opaccAjaxPlugin, opaccLogPlugin } from './vendor/script/opacc.static.js';
import { formErrorMessages } from './vendor/script/messages/opacc.messages.js';

export default class CustomOpaccBasketAction extends TEBasketAction {
    constructor() {
        super();
        this.btnsConfigObj = {};
        this.timeout;
        this.promiseArray = [];
        this.operations = {
            OPERATION_INCREMENT: {
                opName: 'inc',
                opSign: '+',
            },
            OPERATION_DECREMENT: {
                opName: 'dec',
                opSign: '-',
            },
        };
        this.initData();
        this.onInputFieldChanged();
    }

    /**
     *
     *
     * @param {*} e
     * @returns {*} hasChanged
     */
    quantityChanger(e) {
        let hasChanged;

        // get artInternalNo
        const artInternalNo = this.getArtInternalNo(e.target);

        // Mengenstaffelung oder initialer Wert wurden noch nicht ermittelt
        if (!this.btnsConfigObj.hasOwnProperty(artInternalNo)) {
            hasChanged = this.defaultIncrementDecrementFunction(e);
        } else {
            hasChanged = this.calculateNextInputValue(e, artInternalNo);
            const isBasketPage = document.querySelector('.page-basket');
        }

        return hasChanged;
    }

    getAdditionalBtnData() {
        const basketBtnWrappers = document.querySelectorAll('.opc-basket-button');

        if (basketBtnWrappers.length === 0) return;

        basketBtnWrappers.forEach((basketBtnWrapper) => {
            const buttonElement = basketBtnWrapper.querySelector('[data-op-artinternalno]');

            let artInternalNo;
            if (!buttonElement) {
                // check for parent element with data attribute data-basket-art-internal-no
                if (basketBtnWrapper.parentElement.hasAttribute('data-basket-art-internal-no')) {
                    const changeBtn = basketBtnWrapper.querySelector('[data-op-btnaction="change"]');
                    if (changeBtn) {
                        const isVisibleBtn = this.elementIsVisible(changeBtn);

                        if (isVisibleBtn) {
                            artInternalNo = basketBtnWrapper.parentElement.getAttribute('data-basket-art-internal-no');
                        }
                    }
                }
            } else {
                artInternalNo = buttonElement.getAttribute('data-op-artinternalno');
            }

            const quantitySteps = basketBtnWrapper.parentElement.getAttribute('data-te-steps');

            if (!quantitySteps) return;

            this.btnsConfigObj[artInternalNo] = {};
            this.btnsConfigObj[artInternalNo].stepsArray = quantitySteps.split(';');
        });
    }

    initData() {
        this.getAdditionalBtnData();
    }

    defaultIncrementDecrementFunction(e) {
        let decrementButton = e.target.parentElement.querySelector('.opc-button[data-op-qtychange="dec"]');
        let incrementButton = e.target.parentElement.querySelector('.opc-button[data-op-qtychange="inc"]');
        let inputField = e.target.parentElement.querySelector('input.basket-button-quantity');
        let step = parseFloat(inputField.getAttribute('step') || 1);
        let min = parseFloat(inputField.getAttribute('min') || step);
        let max = parseFloat(inputField.getAttribute('max') || 0);
        let isMaxSet = inputField.getAttribute('max') ? true : false;
        let artDimCheck = inputField.dataset.opArtdimcheckcd ? inputField.dataset.opArtdimcheckcd : 0;

        let oldValue = parseFloat(inputField.value) || 0;
        let hasChanged = false;
        let operator = null;

        // Wert erhoehen
        if (incrementButton && e.target === incrementButton) {
            operator = '+';
            if (oldValue < min) {
                operator = '-';
            }
        }
        // Wert verringern
        else if (decrementButton && e.target === decrementButton) {
            operator = '-';
            if (oldValue > max && isMaxSet) {
                operator = '+';
            }
        }
        // Enter-Taste betätigen
        else if (e.keyCode === 13) {
            if (oldValue > max) {
                operator = '+';
            } else if (oldValue < min) {
                operator = '-';
            }
        }

        if (+artDimCheck > 0) {
            let multiplikator = this.countDecimals(step);
            let currentValPow = oldValue * Math.pow(10, multiplikator);
            let stepPow = step * Math.pow(10, multiplikator);
            if (currentValPow === 0 || (currentValPow % stepPow !== 0 && oldValue >= min)) {
                let result = (currentValPow + stepPow - (currentValPow % stepPow)) / Math.pow(10, multiplikator);
                opaccLogPlugin.showMessage(
                    formErrorMessages.messageStepAdjust,
                    formErrorMessages.messageStepAdjust.text
                        .replace('{currentValue}', oldValue)
                        .replace('{newValue}', result)
                        .replace('{step}', step),
                );
                operator = '+';
            }
        }

        hasChanged = this.setCalculatedQuantityField(oldValue, operator, inputField, step, min, max);
        return hasChanged;
    }

    calculateNextInputValue(clickedBtnEvent, artInternalNo) {
        const currentStepArray = this.btnsConfigObj[artInternalNo].stepsArray;

        const clickedBtnElement = clickedBtnEvent.target;
        const quantityBtnWrapper = clickedBtnElement.closest('.basket-button-wrapper');
        const min = currentStepArray[0];
        const max = currentStepArray[currentStepArray.length - 1];

        if (!quantityBtnWrapper) {
            console.error('Missing quantity btn wrapper');
            return;
        }

        const inputElement = quantityBtnWrapper.querySelector('input');

        const currentVal = inputElement.value;

        let nextVal = currentVal;
        let operator;

        if (clickedBtnElement.getAttribute('data-op-qtychange') == this.operations.OPERATION_INCREMENT.opName) {
            nextVal = this.findNextGreaterVal(currentStepArray, currentVal);
            operator = this.operations.OPERATION_INCREMENT.opSign;
        } else if (clickedBtnElement.getAttribute('data-op-qtychange') == this.operations.OPERATION_DECREMENT.opName) {
            nextVal = this.findNextSmallerVal(currentStepArray, currentVal);
            operator = this.operations.OPERATION_DECREMENT.opSign;
        } else {
            console.error('Operationtype not found');
        }

        const step = Math.abs(currentVal - nextVal);

        const hasChanged = this.setCalculatedQuantityField(currentVal, operator, inputElement, step, min, max);

        return hasChanged;
    }

    findNextGreaterVal(array, value) {
        let nextGreaterVal = array.find((element) => parseInt(element) > parseInt(value));

        // check boundaries
        let tmpNextGreaterVal = nextGreaterVal ? nextGreaterVal : value;

        if (tmpNextGreaterVal < parseInt(array[0])) {
            tmpNextGreaterVal = parseInt(array[0]);
        } else if (tmpNextGreaterVal > parseInt(array[array.length - 1])) {
            tmpNextGreaterVal = parseInt(array[array.length - 1]);
        }

        if (array.length === 0 || array[0] === '') {
            tmpNextGreaterVal = parseInt(value) + 1;
        }

        return tmpNextGreaterVal;
    }

    findNextSmallerVal(array, value) {
        let closestSmaller = -1;

        // sort array
        array.sort((a, b) => parseInt(a) - parseInt(b));

        array.forEach((number) => {
            if (parseInt(number) < parseInt(value)) {
                closestSmaller = parseInt(number);
            }
        });

        // check boundaries
        let tmpNextSmallerVal = closestSmaller ? closestSmaller : value;

        if (tmpNextSmallerVal < parseInt(array[0])) {
            tmpNextSmallerVal = parseInt(array[0]);
        } else if (tmpNextSmallerVal > parseInt(array[array.length - 1])) {
            tmpNextSmallerVal = parseInt(array[array.length - 1]);
        }

        // check greater 0
        if (tmpNextSmallerVal <= 0) {
            tmpNextSmallerVal = 1;
        }

        return tmpNextSmallerVal;
    }

    onInputFieldChanged() {
        const basketBtnWrappers = document.querySelectorAll('.opc-basket-button');

        if (basketBtnWrappers.length == 0) return;

        basketBtnWrappers.forEach((basketBtnWrapper) => {
            const inputField = basketBtnWrapper.querySelector('input');

            if (!inputField) return;

            let artInternalNo = this.getArtInternalNo(inputField);

            inputField.addEventListener('keydown', (e) => {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }

                this.timeout = setTimeout(() => {
                    const enteredVal = parseInt(inputField.value);
                    const nextVal = this.getNextCloserVal(inputField.value, artInternalNo);
                    inputField.value = nextVal;

                    if (enteredVal != nextVal) {
                        // show message
                        opaccLogPlugin.showMessage(
                            formErrorMessages.messageToMuchDec,
                            formErrorMessages.messageToMuchDec.text.replace('{newValue}', nextVal),
                        );
                    }
                    this.timeout = null;
                }, 1000);
            });
        });
    }

    getNextCloserVal(value, artInternalNo) {
        let newVal;

        if (!this.btnsConfigObj.hasOwnProperty(artInternalNo)) {
            return value;
        }

        const currentStepArray = this.btnsConfigObj[artInternalNo].stepsArray;

        const nextSmallerVal = this.findNextSmallerVal(currentStepArray, value);
        const nextGreaterVal = this.findNextGreaterVal(currentStepArray, value);

        if (Math.abs(nextGreaterVal - value) < Math.abs(nextSmallerVal - value)) {
            newVal = nextGreaterVal;
        } else {
            newVal = nextSmallerVal;
        }

        return newVal;
    }

    elementIsVisible(element) {
        const style = window.getComputedStyle(element);

        return style.display !== 'none' && style.visibility !== 'hidden';
    }

    getArtInternalNo(btnOrInput) {
        const btnContainer = btnOrInput.closest('.opc-basket-button');
        let currentArtInternalNo;

        const isArtDetailPage = btnContainer.querySelector('[data-op-artinternalno]') != null;

        if (isArtDetailPage) {
            currentArtInternalNo = btnContainer
                .querySelector('[data-op-artinternalno]')
                .getAttribute('data-op-artinternalno');
        } else {
            // basket page
            if (btnContainer.parentElement.hasAttribute('data-basket-art-internal-no')) {
                currentArtInternalNo = btnContainer.parentElement.getAttribute('data-basket-art-internal-no');
            }
        }

        return currentArtInternalNo;
    }

    disableAllElements(wrapperElement, disable) {
        const buttons = wrapperElement.querySelectorAll('button');
        buttons.forEach((button) => {
            button.disabled = disable;
        });

        const inputs = wrapperElement.querySelectorAll('input');
        inputs.forEach((input) => {
            input.disabled = disable;
        });
    }

    onDataLoaded() {
        Promise.all(this.promiseArray).then((values) => {
            // enable all elements
            const elements = document.querySelectorAll('.opc-basket-button');
            elements.forEach((element) => {
                this.disableAllElements(element, false);
            });
        });
    }
}
